import classnames from "classnames";
import React, { ReactNode, useEffect } from "react";
import { Alert, Button } from "reactstrap";

import { ScrollOffsets } from "@utils/enums";
import { scrollToElement } from "@utils/scroll";

import {
    Message,
    MessagePostFix,
} from "@redux/modules/value/messages/messages.utils";

import "./messages.scss";

export type MessageComponentProps = {
    message: Message;
    clearById?: (id: string) => void;
    className?: string;
};

type AlertProps = {
    color: string;
    isOpen?: boolean;
    toggle?: () => void;
    className?: string;
};

const MessageComponent = ({
    message,
    clearById,
    className,
}: MessageComponentProps) => {
    useEffect(() => {
        const { activeScroll = true, id } = message;

        if (activeScroll) {
            setTimeout(() => {
                scrollToElement(id, ScrollOffsets.DEFAULT, true);
            }, 300);
        }
    }, []);

    const addPostFix = (postFix?: MessagePostFix): null | ReactNode => {
        if (!postFix) {
            return null;
        }

        return (
            <Button
                color="link"
                block={false}
                onClick={postFix.onClick}
                className="py-0"
            >
                {postFix.text}
            </Button>
        );
    };

    let alertProps: AlertProps = { color: message.status, className };
    // vanaf isOpen en toggle aanwezig zijn krijg je een sluitings kruisje, ongeacht de waarde
    // Dit kruisje wil je niet zien als het ook niet dismissible is
    if (message.dismissible) {
        alertProps.isOpen = true;
        alertProps.toggle = () => clearById && clearById(message.id);
    }

    return (
        <div
            tabIndex={-1}
            className="messages__message-wrapper"
            id={message.id}
        >
            <Alert {...alertProps}>
                {message.title && (
                    <h4 className={classnames("alert-heading")}>
                        {message.title}
                    </h4>
                )}
                <span
                    dangerouslySetInnerHTML={{
                        __html: message.text,
                    }}
                />
                {addPostFix(message.postFix)}
            </Alert>
        </div>
    );
};

export { MessageComponent };
